import { render, staticRenderFns } from "./educationForm.vue?vue&type=template&id=10b0c0ac&scoped=true&"
import script from "./educationForm.vue?vue&type=script&lang=js&"
export * from "./educationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0c0ac",
  null
  
)

export default component.exports